import { z } from 'zod';

import { MESSAGE } from '@/lib/constants';

// Mirrors `JobCrewScope` in the API layer.
const scope = z.enum(['all', 'upcoming', 'unstarted']);

const validPay = (val: string | undefined, ctx: z.RefinementCtx) => {
  if (!val) return;
  const n = Number(val);
  if (!Number.isFinite(n) || n < 0) {
    ctx.addIssue({ code: 'custom', path: ['payAmount'], message: 'Enter a valid amount' });
  }
};

// Add crew to the series — pay is optional.
export const addCrewSchema = z
  .object({
    employeeId: z.string().trim().min(1, { message: MESSAGE.REQUIRED_FIELD }),
    payAmount: z.string().trim().optional(),
    scope,
  })
  .superRefine((val, ctx) => validPay(val.payAmount, ctx));

export type AddCrewInput = z.infer<typeof addCrewSchema>;

// Change an existing crew member's pay across the series — pay is required.
export const changePaySchema = z
  .object({
    payAmount: z.string().trim().min(1, { message: MESSAGE.REQUIRED_FIELD }),
    scope,
  })
  .superRefine((val, ctx) => validPay(val.payAmount, ctx));

export type ChangePayInput = z.infer<typeof changePaySchema>;
